import SubstainableDevelopmentList from "./SubstainableDevelopmentList";

const SubstainableListPage = ({
}) => {
    return <SubstainableDevelopmentList/>;
}
export default SubstainableListPage;